import { getAccessToken } from "@newsenec/auth-provider";
import { FPPError, buildErrorObj, buildFetchErrorObj, sendErrorObjToBackendIfNew } from "@newsenec/logging";
import { currentLanguage } from "@newsenec/language-provider";
import { mf, mfShorty } from "../../constants";
import { useEffect, useState } from "react";
import { ErrorSerial } from "../../ErrorSerial";

export interface UserTermsOfUse {
    signedLatest: boolean;
    url: string;
    version: string;
}

export interface UseTermsResult {
    isLoading: boolean;
    termsOfUse?: UserTermsOfUse;
    error?: FPPError;
}

export const fetchTerms = async () => {
    const token = await getAccessToken();
    const language = currentLanguage();

    const url = new URL(`${location.origin}/api/fpp/terms/${language}`);
    const method = "GET";

    const response = await fetch(url, {
        method,
        headers: { Authorization: "Bearer " + token },
    });

    if (!response.ok) return Promise.reject(await buildFetchErrorObj(mfShorty, method, response, `FLG_1025_${response.status}`));

    return response.json();
};

export const useTerms = () => {
    const [result, setResult] = useState<UseTermsResult>({ isLoading: true });

    useEffect(() => {
        fetchTerms()
            .then((terms) => setResult({ termsOfUse: terms, isLoading: false }))
            .catch((error) => {
                const errorObj = buildErrorObj(mfShorty, error, ErrorSerial.TERMS_RETRIEVAL);
                setResult({
                    isLoading: false,
                    error: errorObj,
                });
                sendErrorObjToBackendIfNew(mf, mfShorty, errorObj);
            });
    }, []);

    return result;
};

export const approveTerms = async (version: string) => {
    const token = await getAccessToken();
    const language = currentLanguage();

    const url = new URL(`${location.origin}/api/fpp/terms/`);
    url.searchParams.append("version", version);
    url.searchParams.append("language", language);

    const method = "POST";

    const response = await fetch(url, {
        method,
        headers: { Authorization: "Bearer " + token },
    });

    if (!response.ok) return Promise.reject(await buildFetchErrorObj(mfShorty, method, response, ErrorSerial.TERMS_APPROVAL));

    return Promise.resolve();
};
